import { UpperCasePipe } from '@angular/common';
import { Component, computed, inject, input, OnDestroy, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogService } from '../../core/services/dialog.service';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';
import { CurrencySymbolPipe } from '../../pipes/currency-symbol/currency-symbol.pipe';
import { CacheService } from '../../ssr-services/cache/cache.service';
import { SubscriberService } from '../../ssr-services/subscriber/subscriber.service';
import { SelectCurrencyComponent } from './components/select-currency/select-currency.component';
import { SelectLanguageComponent } from './components/select-language/select-language.component';

export enum TabTypes {
  Language = 'language',
  Currency = 'currency',
}

@Component({
  selector: 'app-language-currency-settings',
  templateUrl: './language-currency-settings.component.html',
  styleUrls: ['./language-currency-settings.component.scss'],
  imports: [
    SelectLanguageComponent,
    SelectCurrencyComponent,
    CurrencySymbolPipe,
    UpperCasePipe,
    TranslatePipe,
  ],
})
export class LanguageCurrencySettingsComponent implements OnInit, OnDestroy {
  public activeTab = signal<TabTypes>(TabTypes.Language);

  public TabTypes = TabTypes;

  public subscriberService = inject(SubscriberService);

  public dialogService = inject(DialogService);

  public defaultTab = input(TabTypes.Language);

  public cacheService = inject(CacheService);

  public theme = inject(THEME_SIGNAL);

  public GbTheme = GbTheme;

  public currencyConversionMasterEnabled = computed(() => {
    return this.cacheService.cachedContent()?.cache.config.currencyConversionMasterEnabled;
  });

  public multiLingualMasterEnabled = computed(() => {
    return this.cacheService.cachedContent()?.cache.config.multiLingualMasterEnabled;
  });

  public ngOnInit(): void {
    if (this.multiLingualMasterEnabled() && this.currencyConversionMasterEnabled()) {
      this.activeTab.set(TabTypes.Language);
    } else if (this.currencyConversionMasterEnabled()) {
      this.activeTab.set(TabTypes.Currency);
    } else if (this.multiLingualMasterEnabled()) {
      this.activeTab.set(TabTypes.Language);
    } else {
      this.activeTab.set(this.defaultTab());
    }
  }

  /**
   * Switches between language and currency tabs
   * @param tab - The tab to switch to ('language' or 'currency')
   */
  switchTab(tab: TabTypes): void {
    this.activeTab.set(tab);
  }

  public closeModal() {
    this.dialogService.closeTopDialog();
  }

  ngOnDestroy(): void {
    this.activeTab.set(TabTypes.Language);
  }
}
